import React, { useEffect, useState } from "react";
import ImageLoaderNew from "../../../Components/ImageLoaderNew";
import ImageModal from "../../../Components/ImageModal";
import { NetworkManager } from "../../../Components/NetworkManager";
import ToastManager from "../../../Components/ToastManager";
import GenericPopup from "../../../Components/GenericPopup";
import { useLocation } from "react-router";
let isPublicImageView: boolean = false;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ViewInspectedImg = () => {
  const query = useQuery();
  const id = query.get('id');
  const [orderedImageUrls, setOrderedImageUrls] = useState<string[]>([]);
  const [hoveredImagePath, setHoveredImagePath] = useState<string | null>(null);
  const [galleryPop, setGalleryPop] = useState(false);
  const [startIndex, setStartIndex] = useState<number>(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const [urlExpired, setUrlExpired] = useState(false);
  const [data, setData] = useState<any>({});

  useEffect(()=>{
    isPublicImageView = true
    getTinyUrlDetails();
  },[])

  useEffect(() => {
    if (data?.Images?.length) {
      setOrderedImageUrls(new Array(data.Images.length).fill(null));
    }
  }, [data]);

  const getTinyUrlDetails = () => {
    fetch(`${NetworkManager.serverPath}api/session/tiny-url/images?tinyUrl=${id}`)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        const restData = data;
     if (restData && !restData.errorMessage) {
        const updatedData = {
          ...restData,
          Images: restData?.images?.map((img: any) => ({img: img?.imaeFilePath?.img, comment: img?.imaeFilePath?.comment})) || []
        };
        setData(updatedData);
      }else if (restData.errorMessage == "The Tiny URL has expired.") {
        setUrlExpired(true);
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const handleDownload = async () => {
     if (isDownloading) return;
 
     setIsDownloading(true);
 
     const url = `api/session/download-zip`;
 
     let myHeaders = new Headers();
     myHeaders?.append('Content-Type', 'application/json');
 
     if (localStorage.getItem('token')) {
       const token = 'Bearer ' + localStorage.getItem('token');
       myHeaders?.append('Authorization', token);
     }
 
     try {
       const response = await fetch(NetworkManager.serverPath + url, {
         method: 'POST',
         headers: myHeaders,
         body: JSON.stringify(data?.Images),
       });
       
       if (!response.ok) {
         throw new Error('Download failed with status ' + response.status);
       } 
 
       const blob = await response.blob();
       const downloadUrl = window.URL.createObjectURL(blob);
 
       const a = document.createElement('a');
       a.href = downloadUrl;
       a.download = `${data?.vinNumber}_${data?.Images?.length}_Images_.zip`;
       document.body.appendChild(a);
       a.click();
       a.remove();
       window.URL.revokeObjectURL(downloadUrl);
     } catch (error) {
       console.error('Download error:', error);
       ToastManager.showToast("Download failed", "Error");
     } finally {
       setIsDownloading(false);
       ToastManager.showToast(`${data?.Images?.length} ${data?.Images?.length > 1 ? "Pictures" : "Picture"} have been downloaded successfully`, "Info")
     }
   };

  return (
    <div className="col-12">
      <div className="col-12 d-flex justify-content-start align-items-center img-header" 
          style={{backgroundColor: "#373935", color: "white", height: "100px"}} >
          <div className="mx-5 p-2" >{data?.orgLogo !== "" ? 
            <ImageLoaderNew
              publicUrl={isPublicImageView}
              path={data?.orgLogo}
              index={0}
              onLoad={() => {}}
              style={{ width: "100%", height: "45px", objectFit: "cover", borderRadius: "5px" }}
            /> : <img src={"../../images/finloc.png"} style={{ width: "110px" }} alt="" />}</div>
          <div className="d-flex flex-wrap align-items-center gap-5">
            {data?.vinNumber &&<div className="text-info-block">
              <div className="text-label">Vin Number</div>
              <div><b>{data?.vinNumber}</b></div>
            </div>}
            {data?.brand && <div className="text-info-block">
              <div className="text-label">Brand</div>
              <div><b>{data?.brand}</b></div>
            </div>}
            {data?.year && <div className="text-info-block">
              <div className="text-label">Year</div>
              <div><b>{data?.year}</b></div>
            </div>}
            {data?.unitNumber &&<div className="text-info-block">
              <div className="text-label">Unit Number</div>
              <div><b>{data?.unitNumber}</b></div>
            </div>}
            {data?.licenseNo &&<div className="text-info-block">
              <div className="text-label">License Number</div>
              <div><b>{data?.licenseNo}</b></div>
            </div>}
          </div>
      </div>
      {!urlExpired ? 
      <div className="col-12">
        {data?.Images?.length > 0 && <div className="col-12 text-end my-3 pe-5" style={{textDecoration: "none", color:"#4C80CA"}}>
          <span role="button" className="me-2" onClick={handleDownload}>
            <img src="../../images/download-lite.svg" alt="download" className="mx-1" style={{width: "13px"}} /><u><b>Download All Pictures</b></u>
          </span>
        </div>}
        <div className="col-12">
          <div className="mx-5 image-grid">
            {data?.Images?.map((img: any, index: any)=>(
              <div key={index} className="image-card" 
                onMouseEnter={() => setHoveredImagePath(img?.img)}
                onMouseLeave={() => setHoveredImagePath(null)}
                >
                <div role="button" className="border" style={{ position: "relative" }} onClick={() => {
                        setGalleryPop(true);
                        setStartIndex(index);
                      }}>
                  <ImageLoaderNew
                    publicUrl={isPublicImageView}
                    key={`${img?.img}-${index}`}
                    path={img?.img}
                    index={index}
                    onLoad={(_: number, url: string) => {
                      setOrderedImageUrls((prev: any) => {
                        const newUrls = [...prev];
                        newUrls[index] = {
                          key: img?.img,
                          original: url,
                          comment: img?.comment || null
                        };
                        return newUrls;
                      });
                    }}
                  />
                </div>
            </div>))}
          </div>
        </div>
      </div>:<div className="col-12 d-flex justify-content-center align-items-center" style={{height: "calc(100vh - 200px)"}}>
        <div className="">
        <div className="text-center"><i className="fa-solid fa-triangle-exclamation" style={{color: "red"}}></i></div>
        <b>This url has been expired</b></div>
      </div>}
      <ImageModal
          isOpen={galleryPop}
          imageSrcs={orderedImageUrls}
          startIndex={startIndex}
          caption={""}
          onClose={() => {
            setGalleryPop(false);
            setStartIndex(0);
          }}
        />
      {isDownloading && (
        <GenericPopup
          mode="Share"
          size="sm"
          action={false}
        ><div className="">
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Downloading Pictures...
        </div>
        </GenericPopup>
      )}
    </div>
  );
};

export default ViewInspectedImg;
